import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.1816 2.55344L7.94927 5.00258C7.894 5.07063 7.88337 5.14502 7.91739 5.22582C7.95146 5.30653 8.01307 5.34706 8.10241 5.34706L9.53112 5.34706L9.53112 12.3069C9.53112 12.3664 9.55022 12.4154 9.58849 12.4536C9.62673 12.4918 9.67566 12.511 9.73517 12.511L10.9597 12.511C11.0192 12.511 11.0682 12.4919 11.1064 12.4536C11.1446 12.4153 11.1637 12.3664 11.1637 12.3069L11.1637 5.34701L12.5924 5.34701C12.6775 5.34701 12.7392 5.30642 12.7773 5.22575C12.8115 5.14488 12.7986 5.07049 12.7392 5.00245L10.4811 2.55331C10.4386 2.51079 10.3877 2.48959 10.3281 2.48959C10.273 2.48959 10.2242 2.51093 10.1816 2.55344Z",
      fill: "#00B242"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5.2837 13.447L3.05132 10.9979C2.99605 10.9299 2.98542 10.8555 3.01944 10.7747C3.05351 10.694 3.11512 10.6534 3.20446 10.6534L4.63317 10.6534L4.63317 3.6936C4.63317 3.63404 4.65227 3.58512 4.69054 3.54689C4.72878 3.50869 4.77771 3.4895 4.83722 3.4895L6.06179 3.4895C6.12128 3.4895 6.1702 3.5086 6.2084 3.54687C6.24665 3.58518 6.26575 3.63411 6.26575 3.69357L6.26575 10.6535L7.69444 10.6535C7.77959 10.6535 7.84121 10.6941 7.87936 10.7747C7.91352 10.8556 7.90061 10.93 7.84121 10.998L5.58318 13.4472C5.54069 13.4897 5.48976 13.5109 5.43018 13.5109C5.37504 13.5109 5.32621 13.4896 5.2837 13.447Z",
      fill: "#E11D23"
    }, null, -1)
  ])))
}